
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.85), rgba(30, 58, 138, 0.75)), url('https://public.readdy.ai/ai/img_res/6ce0f84e68e044713840eadc6378b6cd.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-blue-900/50"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-32">
        <div className="text-center">
          <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm font-semibold mb-8 shadow-lg border border-white/20">
            <i className="ri-funds-fill mr-2 text-emerald-400"></i>
            DSCR Loan Financing
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
            Fund Your Investment<br />Property with Confidence
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            In the past year, we have funded two of our rental properties using DSCR loans (worth $2.1M) and we have helped our friends fund theirs. We are now extending our knowledge and expertise to you whether it's your first rental, or if you're considering rental expansion.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-emerald-500 to-blue-500 hover:from-emerald-600 hover:to-blue-600 text-white font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg px-8 py-4"
              onClick={() => {
                const calculator = document.getElementById('dscr-calculator');
                if (calculator) {
                  calculator.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <i className="ri-calculator-line mr-2"></i>
              Calculate Your DSCR
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 backdrop-blur-sm bg-white/10 font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg px-8 py-4"
              onClick={() => window.REACT_APP_NAVIGATE('/#contact')}
            >
              <i className="ri-mail-line mr-2"></i>
              Contact Us Today
            </Button>
          </div>

          {/* Key stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 shadow-xl">
              <div className="text-4xl font-bold text-emerald-400 mb-2">Fast</div>
              <div className="text-white/90 font-medium">Quick Approval Process</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 shadow-lg">
              <div className="text-4xl font-bold text-blue-400 mb-2">Multiple</div>
              <div className="text-white/90 font-medium">Assess Multiple Properties</div>
              <div className="text-white/70 text-sm mt-1">All at the same time</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 shadow-lg">
              <div className="text-4xl font-bold text-white mb-2">No</div>
              <div className="text-white/90 font-medium">No Personal Income Verification</div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
